module.exports = __webpack_public_path__ + "img/baidu-black.fbfb0a3d.svg";